import { z } from 'zod';

export const TalentInterviewEngagementSelectionSchema = z.object({
  engagementSelection: z.string(),
});

export type TalentInterviewEngagementSelection = z.infer<
  typeof TalentInterviewEngagementSelectionSchema
>;
